import httpClient from './httpClient';

class AddressService {
    /**
     * Busca um endereço por ID
     * @param {string|number} id - ID do endereço
     * @param {string|number} customerId - ID do cliente (obrigatório para empresa de transporte)
     * @returns {Promise<Object>} Dados do endereço
     */
    async getById(id, customerId = null) {
        const params = new URLSearchParams();
        if (customerId) {
            params.append('customerId', customerId);
        }
        
        const queryString = params.toString();
        const url = queryString 
            ? `/api/enderecos/${id}/por-id?${queryString}`
            : `/api/enderecos/${id}/por-id`;
            
        const response = await httpClient.get(url);
        
        if (!response.ok) {
            throw new Error(`Erro ao buscar endereço: ${response.status}`);
        }
        
        return response.json();
    }

    /**
     * Busca um endereço por CEP
     * @param {string} zipCode - CEP (apenas números)
     * @returns {Promise<Object>} Dados do endereço
     */
    async getByZipCode(zipCode) {
        const cleanZip = zipCode.replace(/\D/g, '');
        const response = await httpClient.get(`/api/enderecos/${cleanZip}`);
        
        if (!response.ok) {
            throw new Error(`Erro ao buscar endereço por CEP: ${response.status}`);
        }
        
        return response.json();
    }
}

const addressService = new AddressService();
export default addressService;
